module.exports = __webpack_public_path__ + "img/sku-placeholder.0c3b1ce.jpg";